module.exports = __webpack_public_path__ + "img/3.56874b1c.gif";